'use client'
import TokensSm from '@/../public/images/tokens_sm.png';
import HttpStatus from '@/lib/HttpStatus';
import { IUserTokenStatus } from '@/lib/interfaces';
import { ToastError } from '@/lib/sonnerUtils';
import { GetUserTokensStatus } from '@/lib/tokensHandlers';
import Image from "next/image";
import { useEffect, useState } from 'react';
import { useKindeBrowserClient } from "@kinde-oss/kinde-auth-nextjs";
import LoadingGif from '@/../public/loading.gif';

export function TokenBalance({ userId }: { userId?: string}) { 
    const [ remainingTokens, setRemainingTokens ] = useState<number | null>(null);
    const [ userIdLocal, setUserIdLocal ] = useState<string | undefined | null>("");
    const [ isFetchingBalance, setIsFetchingBalance ] = useState<boolean>(true);
    const { user, isLoading, isAuthenticated } = useKindeBrowserClient();
    
    useEffect(() => {
        try {
            
            async function getTokensStatus() {
                setIsFetchingBalance(true);
                console.log(userId, userIdLocal);
                const resp = await GetUserTokensStatus(userId || user?.id!);
                console.log(resp);
                if(resp.status == HttpStatus.OK) setRemainingTokens(resp.data);
                else if(isLoading) setRemainingTokens(null);
                else setRemainingTokens(0);
                setIsFetchingBalance(false);
            }
            setRemainingTokens(null);
            getTokensStatus();

            window.addEventListener('tokens-deducted', getTokensStatus);

            return () => window.removeEventListener('tokens-deducted', getTokensStatus);
        } catch(error) {
            setRemainingTokens(0);
            ToastError(`Problem occured while fetching your remaining tokens. ${(error as Error).message}.`);
        }
    }, [ userIdLocal, userId, isLoading ]);

    return (
        <div className="w-auto flex flex-row">
            <Image src={TokensSm} alt="Carta-AI tokens" width={30} className="object-contain" />
            {
                isFetchingBalance || remainingTokens === null
                ? <Image src={LoadingGif} alt={'Loading Data'} width={30} />
                : <span className="pl-3 text-lg font-medium">{remainingTokens}</span>
            }
        </div>
    )

}